import ri from "./trigger-condition.js";
export default class si {
  constructor(t, i) {
    (this.xu = t), (this.zu = i), (this.xu = t), (this.zu = i);
  }
  Bl(t) {
    if (null == this.xu) return !1;
    const i = ri.Bu(t[0], this.xu);
    if (!i) return !1;
    let r = null == this.zu || 0 === this.zu.length;
    if (null != this.zu)
      for (let i = 0; i < this.zu.length; i++)
        if (this.zu[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new si(t ? t.id : null, t ? t.buttons : null);
  }
  tt() {
    return this.xu;
  }
}
